import ApiService from './ApiService';

class UserService {
  async login(req) {
    try {
      const response = await ApiService.call('public/login', 'POST', req);
      let data = response;

      return {
        data: data,
        success: true,
        message: 'Login successful',
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
  async verify(req) {
    try {
      const response = await ApiService.call('public/verify_otp', 'POST', req);
      let data = response;

      return {
        data: data,
        success: true,
        message: 'Verify successful',
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new UserService();
